import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";

const UnsavedContext = createContext(null);

const CONFIRM_MSG = "Je opname is nog niet opgeslagen. Weet je zeker dat je wilt weggaan?";

export function UnsavedProvider({ children }) {
  const [hasUnsaved, setHasUnsavedState] = useState(false);
  const hasUnsavedRef = useRef(false);

  const setHasUnsaved = useCallback((v) => {
    hasUnsavedRef.current = Boolean(v);
    setHasUnsavedState(Boolean(v));
  }, []);

  // Guard on refresh / tab close / navigation away from the app
  useEffect(() => {
    const handler = (e) => {
      if (!hasUnsavedRef.current) return;
      e.preventDefault();
      // Modern browsers ignore custom messages and show a generic prompt.
      e.returnValue = CONFIRM_MSG;
      return CONFIRM_MSG;
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, []);

  // Synchronous check used by in-app navigation click handlers
  const confirmNavigateAway = useCallback(() => {
    if (!hasUnsavedRef.current) return true;
    return window.confirm(CONFIRM_MSG);
  }, []);

  return (
    <UnsavedContext.Provider value={{ hasUnsaved, setHasUnsaved, confirmNavigateAway }}>
      {children}
    </UnsavedContext.Provider>
  );
}

export function useUnsaved() {
  const ctx = useContext(UnsavedContext);
  if (!ctx) throw new Error("useUnsaved must be used inside UnsavedProvider");
  return ctx;
}
